// src/pages/Home.js

import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock, faChalkboardTeacher, faCameraRetro, faBolt, faGlobe, faUserCog,faShareAlt } from "@fortawesome/free-solid-svg-icons";
import "../styles/Home.css";

const Home = () => {
  return (
    <div className="home-container">
      {/* SEO Metadata */}
      <Helmet>
        <title>GhrianGhraffy - Secure Photo Sharing for Schools</title>
        <meta name="description" content="A secure photo-sharing platform for schools to manage and share photos safely and easily." />
        <meta name="keywords" content="school photo sharing, teachers photo app, school photography management" />
      </Helmet>

      {/* Hero Section */}
      <header className="hero">
        <h1>Welcome to GhrianGhraffy</h1>
        <p className="tagline">Simple, convenient and secure photo-sharing for schools.</p>
        <div className="cta-buttons">
          <Link to="/login" className="cta-button primary">
            Get Started
          </Link>
          <Link to="/learn-more" className="cta-button secondary">
            Learn More
          </Link>
        </div>
      </header>

      {/* Features Section */}
      <section className="features">
        <h2>Why Choose Ghrianghraffy?</h2>
        <div className="feature-cards">
          <div className="feature-card">
            <h3>
              <FontAwesomeIcon icon={faLock} /> Secure Photo Sharing
            </h3>
            <p>Your photos are stored safely and accessible only to Principals, Staff and Parents.</p>
          </div>
          <div className="feature-card">
            <h3>
              <FontAwesomeIcon icon={faBolt} /> Simple & Fast
            </h3>
            <p>Open the App. Take Photos. Upload. Done.</p>
          </div>
          <div className="feature-card">
            <h3>
              <FontAwesomeIcon icon={faGlobe} /> One-Stop-Shop
            </h3>
            <p>One App to show your photos everywhere.</p>
          </div>
          <div className="feature-card">
            <h3>
              <FontAwesomeIcon icon={faShareAlt} /> Multi-Platform Sharing
            </h3>
            <p>Send to your School Website, Instagram and the GhrianGhraffy website simultaneously.</p>
          </div>
          <div className="feature-card">
            <h3>
              <FontAwesomeIcon icon={faUserCog} /> Simple Set-Up
            </h3>
            <p>Copy-and-paste to create your users. One-click photo approvals.</p>
          </div>
          <div className="feature-card">
            <h3>
              <FontAwesomeIcon icon={faChalkboardTeacher} /> Easy Collaboration
            </h3>
            <p>Teachers can share memories with parents in just a few clicks.</p>
          </div>
          <div className="feature-card">
            <h3>
              <FontAwesomeIcon icon={faCameraRetro} /> Hassle-Free Photo Management
            </h3>
            <p>Click-and-forget. No maintenance. Approved photos are uploaded automatically.</p>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials">
        <h2>What Our Users Say</h2>
        <div className="testimonial-cards">
          <div className="testimonial-card">
            <p>
              &quot;Ghrianghraffy has transformed the way we share memories with our school community.
              Teachers love it!&quot;
            </p>
            <h4>- Mrs. Browne, Principal</h4>
          </div>
          <div className="testimonial-card">
            <p>
              &quot;This app makes it so easy to keep parents updated with classroom activities. It&apos;s a
              game changer!&quot;
            </p>
            <h4>- Ms. O&apos;Brien, Teacher</h4>
          </div>
        </div>
      </section>

      {/* Footer Section */}
      <footer className="footer">
        <p>&copy; 2025 Ghrianghraffy. All rights reserved.</p>
        <div className="footer-links">
          <a href="/terms">Terms & Conditions</a>
          <a href="/privacy">Privacy Policy</a>
          <a href="/contact">Contact Us</a>
        </div>
      </footer>
    </div>
  );
};

export default Home;

